import { render, staticRenderFns } from "./rule_manage.vue?vue&type=template&id=22b76682&scoped=true&"
import script from "./rule_manage.vue?vue&type=script&lang=js&"
export * from "./rule_manage.vue?vue&type=script&lang=js&"
import style0 from "./rule_manage.vue?vue&type=style&index=0&id=22b76682&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b76682",
  null
  
)

export default component.exports